/** Preserve recorded seconds consistently in activity feeds and profile/team tables. */
export function activityDuration(seconds: number): string {
    const total = Number.isFinite(seconds) ? Math.max(0, Math.round(seconds)) : 0;
    const hours = Math.floor(total / 3600), minutes = Math.floor(total % 3600 / 60), remaining = total % 60;
    return [hours ? `${hours} hr` : '', minutes ? `${minutes} min` : '', remaining ? `${remaining} sec` : ''].filter(Boolean).join(' ') || '0 min';
}
